import { observable, reaction } from 'mobx';
import { isMobile } from 'react-device-detect';
import { ImageUrlBuilder, ImageCompressionEnum, ImageFormatEnum } from 'kentico-cloud-delivery/_commonjs/lib';
import { Bind } from 'lodash-decorators';
import WINDOW from 'common/consts/window';
import root from 'window-or-global';
import { throttle } from 'lodash';
import { mobileBreakpoint, tabletBreakpoint, desktopBreakpoint, wideDesktopBreakpoint } from 'common/responsive';
import supportsWebP from 'supports-webp';

/* eslint-disable class-methods-use-this */

class WindowStore {
  @observable isOnMobile = false;

  @observable isOnTablet = false;

  @observable isPortraitOrientation = false;

  @observable devicePixelRatio = 1;

  @observable scrollDirection = WINDOW.TOP;

  @observable scrollY = 0;

  @observable windowClickEvent = {};

  constructor() {
    this.onScroll();
    this.onResize();
    root.addEventListener('scroll', throttle(this.onScroll));
    root.addEventListener('resize', throttle(this.onResize));
    root.addEventListener('click', this.onWindowClick);
  }

  reactToScroll(callback, options = {}) {
    return reaction(
      () => this.scrollY,
      (scrollY, theReaction) => callback(scrollY, theReaction),
      options,
    );
  }

  get isOnDesktop() {
    return !this.isOnMobile && !this.isOnTablet;
  }

  @Bind
  onScroll() {
    if (root.scrollY > this.scrollY) {
      this.scrollDirection = WINDOW.BOTTOM;
    } else {
      this.scrollDirection = WINDOW.TOP;
    }
    this.scrollY = root.scrollY;
  }

  @Bind
  onResize() {
    this.isOnMobile = this.checkIfIsOnMobile();
    this.isOnTablet = this.checkIfIsOnTablet();
    this.isPortraitOrientation = this.checkIfPortraitOrientation();
    this.devicePixelRatio = root.devicePixelRatio;
  }

  checkIfPortraitOrientation() {
    return root.matchMedia('(orientation: portrait)').matches;
  }

  @Bind
  onWindowClick(event) {
    this.windowClickEvent = event;
  }

  onClickedAnywhere(callback) {
    return reaction(
      () => this.windowClickEvent,
      (data, theReaction) => callback(data, theReaction),
    );
  }

  checkIfIsOnMobile = () => {
    const query = root.matchMedia(
      `(max-width: ${tabletBreakpoint - 1}px)`,
    );

    return query.matches;
  };

  checkIfIsOnTablet = () => {
    const query = root.matchMedia(
      `(max-width: ${desktopBreakpoint - 1}px)`,
    );

    return query.matches;
  };

  adjustImageSize = (url) => {
    const mobilesBreakpoints = [mobileBreakpoint, tabletBreakpoint, desktopBreakpoint].sort((a, b) => a - b);
    const desktopBreakpoints = [wideDesktopBreakpoint];

    const urlBuilder = new ImageUrlBuilder(url);

    if (isMobile) {
      this.buildURL(mobilesBreakpoints, urlBuilder);
    } else {
      this.buildURL(desktopBreakpoints, urlBuilder);
    }

    return urlBuilder.getUrl();
  }

  buildURL = (breakpoints, urlBuilder) => {
    const getBreakpoint = breakpoints.find(breakpoint => root.innerWidth <= breakpoint);

    urlBuilder
      .withDpr(this.devicePixelRatio);

    if (getBreakpoint) {
      urlBuilder
        .withWidth(getBreakpoint);
    }

    if (supportsWebP) {
      urlBuilder
        .withFormat(ImageFormatEnum.Webp)
        .withCompression(ImageCompressionEnum.Lossy);
    }
  }
}

export default WindowStore;



// WEBPACK FOOTER //
// ./src/stores/Window.store.js